<template>
  <div class="assets-grid" v-if="slotsLen" :style="gridRows">
    <slot></slot>
  </div>
  <el-empty v-else description="暂无数据"></el-empty>
</template>
<script>
export default {
  props: {
    value: {
      type: Array
    },
    max: {
      type: Number
    }
  },

  data() {
    return {
      slotsLen: 0
    }
  },

  provide() {
    return {
      itemChange: this.onItemsChange
    }
  },
  updated() {
    this.$nextTick(() => {
      this.slotsLen = this.$slots?.default?.length || 0
    })
  },
  computed: {
    valueIds() {
      return this.value.map((v) => v.id)
    },

    gridRows() {
      return `grid-template-rows: repeat(${Math.ceil(this.slotsLen / 4)}, 194px);`
    }
  },

  methods: {
    /**
     * @description: emit v-model when grid-item clicked
     * @param {*} grid
     */
    onItemsChange(grid) {
      // 素材管控
      if (grid.ruleId) return
      let newValue = this.value
      if (this.valueIds.includes(grid.id)) {
        newValue = newValue.filter((row) => row.id !== grid.id)
      } else {
        newValue = [grid, ...newValue]
        // this.max = -1 代表可以选择无限个
        if (this.max >= 0) {
          newValue = newValue.slice(0, this.max)
        }
      }

      this.$emit('input', newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.assets-grid {
  margin-top: 4px;
  height: 100%;
  overflow: auto;
  display: grid;
  grid-auto-flow: row;
  // grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  grid-template-columns: repeat(4, minmax(260px, 1fr));
  grid-gap: 8px;
  grid-template-rows: repeat(4, 164px);
}
</style>
